export enum FlowcodeThemes {
  DarkStandard = 1,
  DarkInverted = 2,
  LightStandard = 3,
  LightInverted = 4
}
